import React from 'react';
import { Box, RawButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

export const StyledButton = styled(RawButton)`
  border-radius: ${({ theme }) => theme.rounds.fieldRound};
  transition: all 0.2s;
  height: ${({ theme }) => theme.spacings.xl};
  min-height: ${({ theme }) => theme.spacings.xl};
  color: ${({ theme }) => theme.colors.textBody};
  &:hover {
    background-color: ${({ theme }) => theme.colors.accentContainer};
    color: ${({ theme }) => theme.colors.textAccent};
  }
  &:active {
    svg {
      fill: ${({ theme }) => theme.colors.textOnColor};
    }

    background-color: ${({ theme }) => theme.colors.buttonSecondaryActiveBorder};
    color: ${({ theme }) => theme.colors.textOnColor};
  }
`;

interface Props {
  testId?: string;
  text?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}

const DropdownButton: React.FC<Props> = ({ testId, text, icon, onClick }) => {
  return (
    <StyledButton data-testid={`${testId}_button`} onClick={onClick} margin={{ top: 'spacing8' }}>
      <Box direction="row" align="center" pad={{ horizontal: 'xs', vertical: 'xxs' }}>
        {icon}
        <Box margin={{ left: 'spacing12' }}>
          <Text size="medium" weight="normal">
            {text}
          </Text>
        </Box>
      </Box>
    </StyledButton>
  );
};

export default DropdownButton;
